import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'
import { getQuarterlyReports, selectLoadingState, selectQuarterlyReports } from '../slice'
import QuarterlyReportsTable from './QuarterlyReportsTable'
import useCustomerNumber from '../../../../hooks/useCustomerNumber'

const QuarterlyReports = () => {
  const dispatch = useAppDispatch()
  const customerNumber = useCustomerNumber()
  const quarterlyReports = useAppSelector(selectQuarterlyReports)
  const loadingState = useAppSelector(selectLoadingState)

  useEffect(() => {
    const needsData = customerNumber && !quarterlyReports && loadingState.quarterlyReports === 'not-asked'

    if (needsData) {
      dispatch(getQuarterlyReports(customerNumber))
    }
  }, [customerNumber, quarterlyReports, loadingState.quarterlyReports])

  return (
    <>
      {quarterlyReports && quarterlyReports.length > 0 && (
        <QuarterlyReportsTable
          customerNumber={customerNumber}
          quarterlyReports={quarterlyReports}
        />
      )}
      {loadingState.quarterlyReports === 'done' && !quarterlyReports?.length && (
        <div className='p-16 center'>
          You have no quarterly Biological Monitoring reports at this time. This section displays quarterly
          reports summarizing your Biological Monitoring. To receive this report you can either log your test results in the
          Biological Monitoring area of OnTraq or use our HealthFirst Mail-In product to have test results automatically displayed.
        </div>
      )}
    </>
  )
}

export default QuarterlyReports